import {WS_ENDPOINT} from './index'
import Cookies from 'js-cookie'
import {Constant} from '../common/constant'
const token = Cookies.get(Constant.TOKEN_NAME)

export default {
  getSocket () {
    return new WebSocket(`${WS_ENDPOINT}?token=${token}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/socket.js